<template>
  <div>
    <Header navTitle="待提报工时列表" navTip="系统发现你参与案件中存在未报情况，请及时处理！"></Header>
    <div class="caseBox">
      <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
        <van-list
          style="height: calc(100% - 200px)"
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template v-for="(item, index) in state.list" :key="item">
            <div class="box" @click="onJump(item.id)">
              <div
                class="line"
                :style="{ background: colorList[index % 3] }"
              ></div>
              <div class="box_cont">
                <div class="title">{{item.caseName}}</div>
                <div class="time">
                  <van-icon style="margin-right: 8px" name="clock-o" />
                  {{item.planName}}/计划完成时间 {{item.planEndTime.split(' ')[0]}}
                </div>
                <div class="status">
                  <van-icon style="margin-right: 8px" name="fire-o" />
                  {{item.finishStatus_dictText}}
                </div>
              </div>
              <van-icon color="#a0a0a0" size="16" name="arrow" />
            </div>
          </template>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script lang="ts">
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import { List, Icon, PullRefresh } from 'vant';
import { useRouter } from 'vue-router';
import getList from '@/http/stayCase';

export default defineComponent({
  components: {
    [List.name]: List,
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    Header,
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const pages = reactive({
      pageNo: 0,
      pageSize: 5,
    });
    const colorList = ref(['#A7ffd9', '#fffca7', '#dec8ff']);
    const onLoad = () => {
      pages.pageNo += 1;
      getList(pages).then((res: any) => {
        const { total } = res.result;
        const {
          result: { records },
        }: { result: { records: [] } } = res;
        state.refreshing = false;
        state.list.push(...records);
        state.loading = false;
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    const onJump = (pro:any) => {
      router.push({
        path: '/caseForm',
        query: { projectId: pro, type: 1 },
      });
    };
    return {
      state,
      onLoad,
      colorList,
      onRefresh,
      onJump,
    };
  },
});
</script>

<style lang="scss" scoped>
.caseBox {
  margin-top: 20px;
  padding: 0 10px;
  height: calc(100vh - 200px);
  overflow: auto;
  .box {
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    margin-bottom: 10px;
    border-radius: 15px;
    position: relative;
    .line {
      display: inline-block;
      width: 10px;
      margin-right: 10px;
      background: red;
      height: 100%;
      position: absolute;
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
    }
    &_cont {
      padding: 10px 0 10px 20px;
      width: calc(100% - 40px);
      flex: 1;
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow: hidden;
      }
      .time {
        font-size: 14px;
        color: #a6a6a6;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
      }
      .status {
        font-size: 14px;
        color: #a6a6a6;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
